import { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useHousehold } from "@/context/HouseholdContext";
import { toast } from "sonner";

export default function AcceptInvite() {
  const location = useLocation();
  const { reload, setActiveId } = useHousehold();
  const [done, setDone] = useState(false);

  useEffect(() => {
    const token = new URLSearchParams(location.search).get("token");
    if (!token) { setDone(true); return; }
    (async () => {
      try {
        const res = await api.post("/invites/accept", { token });
        await reload(); setActiveId(res.data.household_id);
        toast.success("You've joined the household");
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Could not accept invite");
      } finally { setDone(true); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (done) return <Navigate to="/networth" replace />;
  return <div className="min-h-screen flex items-center justify-center bg-background"><div className="text-sm uppercase tracking-[0.3em] text-muted-foreground animate-pulse">Joining household…</div></div>;
}
